var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgChevronDown = function SvgChevronDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 8,
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColour",
    fillRule: "evenodd",
    d: "M7.53 7.53a.75.75 0 0 1-1.06 0l-6-6A.75.75 0 0 1 1.53.47L7 5.94 12.47.47a.75.75 0 1 1 1.06 1.06z",
    clipRule: "evenodd"
  })));
};
export default SvgChevronDown;